let timer;

if(document.querySelector('.js-Filter')){
  document.querySelector('.js-Filter').addEventListener('change', function(event) {
      // Clear any existing timer to prevent multiple refreshes
      clearTimeout(timer);

      const params = new URLSearchParams();

      // Check if a checkbox was changed
      if (event.target.type === 'checkbox') {
          // Uncheck all checkboxes except the one just clicked
          document.querySelectorAll('.js-Filter input[type="checkbox"]').forEach(function(checkbox) {
              if (checkbox !== event.target) {
                  checkbox.checked = false;
              }
          });
      }

      // Loop through each input field and checkbox in the form
      document.querySelectorAll('.js-Filter input, .js-Filter select').forEach(function(input) {
          if (input.type === 'checkbox') {
              // Add checkbox value only if it's checked
              params.set(input.name, input.checked ? 'true' : 'false');
          } else if (input.value) {
              // Handle other input types (text, select, etc.)
              params.set(input.name, input.value);
          }
      });

      // Set a delay before refreshing the page
      timer = setTimeout(function() {
          window.location.search = params.toString();
      }, 500); // 500ms delay before refresh
  });
}
